export const APP_AGE_GROUP = '8-13' as string;
